import { useLocation } from 'react-router-dom';

export const usePage = () => {
  const location = useLocation();
  return location.pathname.split('/')[1];
};
